import isWeb from './isWeb';

let isWQ = false;

if (isWeb) {
    const ua = (navigator && navigator.userAgent) || '';
    isWQ = /MicroMessenger/i.test(ua) || /QQ/i.test(ua);
}

export default isWQ;
